import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowInsurancePreviewTemplate } from "themes/application/facility-order-new-flow-insurance/pages";
import { FacilityOrderNewFlowInsurancePreviewViewStore } from "application/facility-order-new-flow-insurance/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowInsurancePreviewViewStore(rootStore), "facilityOrderNewFlowInsurancePreviewViewStore")
@observer
class FacilityOrderNewFlowInsurancePreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowInsurancePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowInsurancePreview;